import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import {
  Theme,
  Card,
  Flex,
  Text,
  Link,
  Button,
  Separator,
} from "@radix-ui/themes";
import { FaLinkedin, FaGithub, FaTwitter, FaGlobe } from "react-icons/fa";
import Cal from "@calcom/embed-react";

function CrimsonBold({ user }) {
  const [showCalendar, setShowCalendar] = useState(false);

  return (
    <Theme appearance="dark" accentColor="crimson">
      <Helmet>
        <title>{user?.name} | Profiles</title>
        <meta
          name="description"
          content={`${user?.name}'s profile on Profiler. View links, bio, and schedule meetings.`}
        />
      </Helmet>
      <div style={{ background: "#1a0000", height: "100vh" }}>
        {!showCalendar ? (
          <Flex
            align="center"
            justify="center"
            style={{ height: "100%", padding: "2rem" }}
          >
            <Card
              size="4"
              style={{
                maxWidth: "480px",
                width: "100%",
                borderRadius: "20px",
                background: "rgba(32, 0, 0, 0.7)",
                border: "1px solid crimson",
                boxShadow: "0 0 30px rgba(220, 20, 60, 0.5)",
                backdropFilter: "blur(12px)",
                padding: "2rem",
                color: "#fff",
              }}
            >
              <Flex direction="column" align="center" gap="3">
                <Text size="6" weight="bold" color="crimson">
                  {user.name}
                </Text>
                <Text color="gray">@{user.username}</Text>
              </Flex>

              <Separator
                my="3"
                size="4"
                style={{ backgroundColor: "crimson" }}
              />

              <Text align="center" my="3">
                {user.description}
              </Text>

              <Flex justify="center" gap="4" wrap="wrap" my="3">
                {user.socialLinks?.linkedin && (
                  <Link href={user.socialLinks.linkedin} target="_blank">
                    <Flex align="center" gap="1">
                      <FaLinkedin size={20} />
                      <Text>LinkedIn</Text>
                    </Flex>
                  </Link>
                )}
                {user.socialLinks?.github && (
                  <Link href={user.socialLinks.github} target="_blank">
                    <Flex align="center" gap="1">
                      <FaGithub size={20} />
                      <Text>GitHub</Text>
                    </Flex>
                  </Link>
                )}
                {user.socialLinks?.twitter && (
                  <Link href={user.socialLinks.twitter} target="_blank">
                    <Flex align="center" gap="1">
                      <FaTwitter size={20} />
                      <Text>Twitter</Text>
                    </Flex>
                  </Link>
                )}
                {user.socialLinks?.website && (
                  <Link href={user.socialLinks.website} target="_blank">
                    <Flex align="center" gap="1">
                      <FaGlobe size={20} />
                      <Text>Website</Text>
                    </Flex>
                  </Link>
                )}
              </Flex>

              {user.calcomUsername && (
                <Flex justify="center" mt="4">
                  <Button
                    variant="solid"
                    color="crimson"
                    onClick={() => setShowCalendar(true)}
                  >
                    Schedule Meeting
                  </Button>
                </Flex>
              )}
            </Card>
          </Flex>
        ) : (
          <Flex
            justify="center"
            style={{ height: "100%", animation: "fadeIn 400ms ease-in-out" }}
          >
            <div
              style={{ width: "100%", overflow: "hidden", marginTop: "4rem" }}
            >
              <Cal calLink={`${user.calcomUsername}/15min`} />
            </div>
          </Flex>
        )}

        <style>
          {`
            @keyframes fadeIn {
              from { opacity: 0; transform: translateY(10px); }
              to { opacity: 1; transform: translateY(0); }
            }
          `}
        </style>
      </div>
    </Theme>
  );
}

export default CrimsonBold;
